import { useDispatch } from "react-redux";

import {
  resetTabFilters,
  setActiveTab,
  setStoreCode,
  setStoreHealth,
  setTabFilter,
} from "../index";
import {
  AccessTab,
  SetTabFilterPayload,
  StoreHealthEntry,
  TabFilters,
} from "../types";

export const useStoreAccessFilterActions = () => {
  const dispatch = useDispatch();

  const updateStoreCode = (code: number | null) =>
    dispatch(setStoreCode(code));

  const updateActiveTab = (tab: AccessTab) => dispatch(setActiveTab(tab));

  /**
   * Atualiza UM filtro de UMA tab.
   *
   * Uso típico:
   * ```ts
   * updateTabFilter({ tab: "users", key: "search", value: "Maria" });
   * ```
   */
  const updateTabFilter = <K extends keyof TabFilters>(
    payload: SetTabFilterPayload<K>,
  ) => dispatch(setTabFilter(payload as SetTabFilterPayload));

  const resetTab = (tab: AccessTab) => dispatch(resetTabFilters(tab));

  const updateStoreHealth = (storeCode: number, health: StoreHealthEntry) =>
    dispatch(setStoreHealth({ storeCode, health }));

  return {
    updateStoreCode,
    updateActiveTab,
    updateTabFilter,
    resetTab,
    updateStoreHealth,
  };
};
